<template>
  <UlSelect
    v-if="languageList.length"
    v-model="languageCode"
    :class="{
      'switcher-uk': isUaRu
    }"
    :menu-props="{ contentClass: 'my-1' }"
    :options="languageList"
    :has-border="hasBorder"
    class="switcher"
    return-object
    @change="changeLanguage"
  >
    <template #optionPrepend="{ item }">
      <v-img
        :src="$asset(`img/countryFlags/${getFlagImage(item.countryCode)}.svg`)"
        class="mr-1"
        contain
        max-width="16px"
      />
    </template>
    <template #selection="{ item }">
      <v-img
        contain
        max-width="16px"
        class="mr-1"
        :src="$asset(`img/countryFlags/${getFlagImage(item.countryCode)}.svg`)"
      />
      {{ item.value }}
    </template>
  </UlSelect>
</template>

<script>
import { mapGetters } from 'vuex';
import languagePicker from '@/mixins/languagePicker';
import oldWebRedirect from '@/mixins/oldWebRedirect';
import { uaRuRouteNames } from '@/router/routes';

export default {
  name: 'LanguageSwitcher',
  mixins: [languagePicker, oldWebRedirect],
  props: {
    redirectType: {
      type: String,
      default: 'locale'
    },
    hasBorder: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      languageCode: 'cs'
    };
  },
  computed: {
    languageList() {
      const uaList = [
        {
          id: 'uk',
          countryCode: 'UA',
          countryCodePrint: 'UK',
          value: this.$t('languageSwitcher.uk')
        },
        {
          id: 'ru',
          countryCode: 'RU',
          value: this.$t('languageSwitcher.ru')
        }
      ];

      let langList = [];

      if (
        !!this.$route.name &&
        this.$route.name.startsWith('hrb') &&
        !!this.partnerData &&
        Object.keys(this.partnerData).length
      ) {
        this.partnerMutations.forEach(
          val => (langList = langList.concat(this.getLanguagesByCode(val.language)))
        );
        return langList;
      }

      if (this.isHu) {
        langList = [
          {
            id: 'hu',
            countryCode: 'HU',
            countryCodePrint: 'HU',
            value: this.$t('languageSwitcher.hu')
          },
          {
            id: 'en',
            countryCode: 'GB',
            countryCodePrint: 'EN',
            value: this.$t('languageSwitcher.en')
          }
        ];
        return langList;
      }

      langList = [
        {
          id: this.$domainRegion === 'cz' ? 'cs' : 'sk',
          countryCode: this.$domainRegion === 'cz' ? 'CZ' : 'SK',
          value:
            this.$domainRegion === 'cz'
              ? this.$t('languageSwitcher.cz')
              : this.$t('languageSwitcher.sk')
        },
        {
          id: 'en',
          countryCode: 'GB',
          countryCodePrint: 'EN',
          value: this.$t('languageSwitcher.en')
        }
      ];

      if (
        !!this.$route.name &&
        this.$route.name.startsWith('thematicCounselling') &&
        this.isPutinSucks
      ) {
        return uaList;
      }

      if (uaRuRouteNames.includes(this.currentPath)) {
        return langList.concat(uaList);
      }

      return langList;
    },
    currentLanguage() {
      return this.$i18n.locale;
    },
    ...mapGetters({
      partnerData: 'hrbPartner/partnerData'
    }),
    partnerMutations() {
      return this.partnerData.mutations || [];
    }
  },
  watch: {
    currentLanguage() {
      this.updateLang();
    }
  },
  created() {
    this.updateLang();
  },
  methods: {
    changeLanguage() {
      localStorage.removeItem('daktelaWebCliState');
      localStorage.removeItem('daktelaWebGUIState');

      this.gtmSelectLanguage(this.languageCode.id);

      if (
        this.languageCode.id === 'cs' &&
        this.languageSwitcherOverridePaths.includes(this.currentPath)
      ) {
        location.href = import.meta.env.VITE_OLD_WEB_URL;
        return;
      }

      const nextLocation = this.$switchLocalePath(this.languageCode.id);
      if (this.redirectType === 'refresh') {
        location.href = `${location.origin}${nextLocation}`;
      } else {
        this.$router.push(nextLocation);
      }
      this.$emit('close');
    },
    updateLang() {
      let selectedLanguage = this.languageList.find(val => this.currentLanguage === val.id);
      this.languageCode = selectedLanguage ?? 'cs';
    }
  }
};
</script>

<style lang="scss">
.switcher {
  width: 150px !important;

  &.switcher-uk {
    width: 183px !important;
  }
}
</style>
